<template>
    <v-container fluid>
        <v-expand-transition>
            <form v-if="showForm" slot="leftContainer" autocomplete="nope" class="mb-4" data-vv-scope="form-2" @submit.prevent="addCotizacion('form-2')">
                <v-card>
                    <v-card-title class="grey lighten-4">
                        <b>Generar Cotizaciones</b>
                    </v-card-title>
                    <v-card-text class="pa-4">
                        <!-- ======================== -->
                        <!-- DATOS DEL PRODUCTO -->
                        <!-- ======================== -->
                        <v-row dense>
                            <v-col cols="12">
                                <v-divider></v-divider>
                                <h4 class="py-2 font-weight-bold primary--text">DATOS DEL PRODUCTO</h4>
                            </v-col>
                            <v-col cols="12">
                                <SelectProductos show-plantillas></SelectProductos>
                            </v-col>
                        </v-row>

                        <!-- ======================== -->
                        <!-- DATOS DEL PROYECTO -->
                        <!-- ======================== -->
                        <v-row dense class="mt-2">
                            <v-col cols="12">
                                <h5 class="py-1 font-weight-medium grey--text text--darken-1">DATOS DEL PROYECTO</h5>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field
                                    dense
                                    v-model="form.largo"
                                    data-vv-name="form.largo"
                                    :error-messages="errors.collect('form.largo')"
                                    label="Largo (cm)"
                                    @keypress="isNumber"
                                />
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field
                                    dense
                                    v-model="form.ancho"
                                    data-vv-name="form.ancho"
                                    :error-messages="errors.collect('form.ancho')"
                                    label="Ancho (cm)"
                                    @keypress="isNumber"
                                />
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field
                                    dense
                                    v-model="form.alto"
                                    data-vv-name="form.alto"
                                    :error-messages="errors.collect('form.alto')"
                                    label="Alto (cm)"
                                    @keypress="isNumber"
                                />
                            </v-col>
                        </v-row>

                        <!-- ======================== -->
                        <!-- DATOS DEL CLIENTE -->
                        <!-- ======================== -->
                        <v-row dense align="center" class="py-4">
                            <v-col cols="12">
                                <v-divider></v-divider>
                                <h4 class="py-2 font-weight-bold primary--text">DATOS DEL CLIENTE</h4>
                            </v-col>
                            <v-col cols="12"> <v-checkbox dense v-model="form.tieneDatosCliente" label="¿Tengo datos del cliente?"></v-checkbox></v-col>
                            <v-col cols="12" v-if="form.tieneDatosCliente">
                                <v-row align="center">
                                    <v-col cols="12">
                                        <ClientePanel ref="clientePanel" v-model="form.idCliente" @client-selected="onClientePanelSelected" />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" v-else>
                                <v-row>
                                    <v-col cols="12" sm="9">
                                        <v-text-field dense v-model="form.nameDefault" label="Nombre Cliente" placeholder="Innout Sac" />
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field dense v-model="form.telefono" label="Telf Contacto" placeholder="986193329" />
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field dense v-model="form.correo" label="Correo" placeholder="hola@innout.pe" />
                                    </v-col>
                                    <v-col cols="12" sm="3" class="d-flex align-center">
                                        <v-btn color="primary" small :disabled="!form.nameDefault" @click="crearClienteDesdeForm">
                                            <v-icon left small>mdi-account-plus</v-icon>
                                            Crear Cliente
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <!-- Cuando hay cliente, mostrar telefono/correo como informativo -->
                            <v-col cols="12" sm="2" v-if="form.idCliente && form.telefono">
                                <v-text-field dense :value="form.telefono" label="Telf Cliente" readonly />
                            </v-col>
                            <v-col cols="12" sm="3" v-if="form.idCliente && form.correo">
                                <v-text-field dense :value="form.correo" label="Correo Cliente" readonly />
                            </v-col>
                        </v-row>

                        <!-- ======================== -->
                        <!-- DATOS DE ENVÍO -->
                        <!-- ======================== -->
                        <v-row dense align="center" class="py-2">
                            <v-col cols="12">
                                <v-divider></v-divider>
                                <h4 class="py-2 font-weight-bold primary--text">DATOS DE ENVÍO</h4>
                            </v-col>
                            <v-col cols="12" v-if="form.idCliente">
                                <v-checkbox
                                    dense
                                    v-model="usarDireccionCliente"
                                    label="Usar la dirección del cliente"
                                    hint="Si marca esta opción se usará la dirección registrada del cliente"
                                    persistent-hint
                                />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <SelectUbigeo v-model="isDistrito" label="Distrito de envío" :disabled="usarDireccionCliente && !!form.idCliente" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field
                                    dense
                                    v-model="form.direccion"
                                    label="Dirección de envío"
                                    placeholder="jr jose de la mar 469"
                                    :disabled="usarDireccionCliente && !!form.idCliente"
                                />
                            </v-col>
                        </v-row>

                        <!-- ======================== -->
                        <!-- CONDICIONES DE LA COTIZACIÓN -->
                        <!-- ======================== -->
                        <v-row dense>
                            <v-col cols="12">
                                <v-divider></v-divider>
                                <h4 class="py-2 font-weight-bold primary--text">CONDICIONES DE LA COTIZACIÓN</h4>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-autocomplete
                                    dense
                                    v-model="form.idTipoComprobante"
                                    v-validate="'required'"
                                    :items="tipoComprobanteFact"
                                    item-text="descripcion"
                                    placeholder="Boleta"
                                    item-value="id"
                                    :error-messages="errors.collect('form.idTipoComprobante')"
                                    label="Tipo Comprobante"
                                    data-vv-name="form.idTipoComprobante"
                                    data-vv-as="Tipo"
                                    required
                                />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-autocomplete
                                    dense
                                    v-model="form.idTipoPago"
                                    v-validate="'required'"
                                    :items="tipoPago"
                                    item-text="descripcion"
                                    placeholder="Contado"
                                    item-value="id"
                                    :error-messages="errors.collect('form.idTipoPago')"
                                    label="Tipo pago"
                                    data-vv-name="form.idTipoPago"
                                    data-vv-as="Tipo"
                                    required
                                />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-menu
                                    dense
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            dense
                                            v-model="form.fechaEmision"
                                            label="Fecha de Emisión"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            data-vv-name="form.fechaEmision"
                                            data-vv-as="fecha Emisión"
                                            :error-messages="errors.collect('form.fechaEmision')"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker dense v-model="form.fechaEmision" no-title locale="es" @input="menu = false" />
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-menu
                                    dense
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            dense
                                            v-model="form.fechaVencimiento"
                                            label="Fecha de Vencimiento"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            data-vv-name="form.fechaVencimiento"
                                            data-vv-as="fecha cotizacion"
                                            :error-messages="errors.collect('form.fechaVencimiento')"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker dense v-model="form.fechaVencimiento" no-title locale="es" @input="menu2 = false" />
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="2" v-if="form.idTipoMoneda === 2">
                                <v-text-field
                                    v-validate="'decimal'"
                                    data-vv-name="form.tipoCambio"
                                    data-vv-as="Tipo de Cambio"
                                    :error-messages="errors.collect('form.tipoCambio')"
                                    placeholder="Ej: 3.75"
                                    dense
                                    @keypress="isNumber"
                                    v-model="form.tipoCambio"
                                    label="Tipo Cambio $"
                                    hint="Opcional"
                                    persistent-hint
                                />
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field dense v-model="form.diasEntrega" label="Días de entrega" @keypress="isNumber" placeholder="10"
                            /></v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete
                                    dense
                                    v-model="formaPagoSelected"
                                    :items="opcionesFormaPago"
                                    item-text="text"
                                    item-value="value"
                                    label="Forma de Pago"
                                    placeholder="Seleccione forma de pago"
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" sm="6" v-if="formaPagoSelected === '__OTRO__'">
                                <v-text-field
                                    dense
                                    v-model="form.formaPago"
                                    label="Especifique la forma de pago"
                                    placeholder="Ej: 30% adelanto, 70% contraentrega"
                                />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-select
                                    clearable
                                    v-validate="'required'"
                                    :error-messages="errors.collect('form.origen')"
                                    data-vv-name="form.origen"
                                    data-vv-as="origen"
                                    dense
                                    v-model="form.origen"
                                    :items="listOrigen"
                                    placeholder="SELECCIONAR ORIGEN"
                                    label="SELECCIONAR ORIGEN"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" v-if="form.origen == 'OTROS'">
                                <v-text-field
                                    v-validate="'required'"
                                    :error-messages="errors.collect('form.altOrigen')"
                                    data-vv-name="form.altOrigen"
                                    data-vv-as="altOrigen"
                                    dense
                                    v-model="form.altOrigen"
                                    label="Ingresar origen"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-text-field dense v-model="form.observaciones" label="Detalles Extras (Se muestra en el PDF)" placeholder=""
                            /></v-col>
                            <v-col cols="12" sm="12">
                                <v-textarea dense v-model="form.description" rows="2" auto-grow label="Nota / Consulta del Cliente" placeholder=""
                            /></v-col>
                            <b class="red--text"> {{ form.isSendMail ? '¡Ya se envió un email anteriormente!' : '' }} </b>
                        </v-row>

                        <!-- ======================== -->
                        <!-- NOTIFICACIÓN AL CLIENTE -->
                        <!-- ======================== -->
                        <v-row dense>
                            <v-col cols="12">
                                <v-divider></v-divider>
                                <h4 class="py-2 font-weight-bold primary--text">NOTIFICACIÓN AL CLIENTE</h4>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field
                                    dense
                                    :value="form.telefono || '—'"
                                    label="Teléfono para WhatsApp"
                                    readonly
                                    :hint="form.telefono ? '' : 'Complete el teléfono en Datos del Cliente'"
                                    persistent-hint
                                />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-textarea dense v-model="form.urlProducto" label="URL del producto" placeholder="https://..." rows="2" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-textarea dense v-model="mensajeNotificacion" label="Notas para el mensaje" placeholder="" rows="2" />
                            </v-col>
                            <v-col cols="12" sm="1" class="d-flex align-center">
                                <v-btn @click="sendWhatsapp" small dark color="green" :disabled="!form.telefono" title="Enviar WhatsApp">
                                    <v-icon>mdi-whatsapp</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="2" class="d-flex align-center">
                                <v-switch dense v-model="form.sendMail" label="Enviar correo"></v-switch>
                            </v-col>
                        </v-row>
                        <v-col cols="12" sm="12">
                            <h3 class="text-right">
                                Importe Total {{ form.idTipoMoneda === 1 ? 'S/.' : '$' }}
                                {{ form.idTipoMoneda === 1 ? `${importe.sumaSoles}` : `${importe.sumaDolares}` }}
                            </h3>
                        </v-col>

                        <v-row dense v-if="stateUpdate" class="mt-2">
                            <v-col cols="12">
                                <v-divider></v-divider>
                                <h4 class="py-2 font-weight-bold primary--text">ESTADO DE COTIZACIÓN</h4>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-chip small :color="estadoColor(form.idEstado)" text-color="white">
                                    {{ estadoLabel({ idEstado: form.idEstado, idVenta: form.idVenta }) }}
                                </v-chip>
                            </v-col>
                            <v-col cols="12" sm="6" class="text-right">
                                <v-btn small color="purple" dark @click="openModalEstadoDesdeForm">
                                    <v-icon left small>mdi-flag-outline</v-icon>
                                    Cambiar Estado
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-col cols="12" sm="6" class="mt-2 align-right">
                            <v-btn type="submit" large :loading="loading" dark :color="step == 1 ? 'primary' : 'orange'" block>
                                <b>{{ step == '1' ? 'GENERAR COTIZACION' : 'Actualizar' }}</b>
                            </v-btn>
                        </v-col>
                    </v-card-text>
                </v-card>
            </form>
        </v-expand-transition>
        <v-card slot="rightContainer" outlined>
            <v-dialog v-model="modalReserva.state" scrollable max-width="1024" persistent transition="dialog-bottom-transition">
                <ModalReserva v-if="modalReserva.state" />
            </v-dialog>
            <div>
                <v-container fluid>
                    <v-card>
                        <v-card-text>
                            <v-row align="center" justify="center">
                                <v-col cols="12" sm="8">
                                    <v-row class="grey lighten-4" align="center" justify="center">
                                        <v-col cols="12"> <strong>FILTROS</strong></v-col>
                                        <v-col cols="12" sm="3">
                                            <v-menu
                                                v-model="menu3"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="auto"
                                            >
                                                <template #activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="fechaFiltro"
                                                        dense
                                                        label="DESDE"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        hide-details="auto"
                                                        clearable
                                                        @click:clear="fechaFiltro = format(subMonths(new Date(), 1), 'yyyy-MM-dd')"
                                                    />
                                                </template>
                                                <v-date-picker v-model="fechaFiltro" no-title scrollable @input="menu3 = false" />
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-menu
                                                v-model="menu4"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="auto"
                                            >
                                                <template #activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="fechaHasta"
                                                        dense
                                                        label="HASTA"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        hide-details="auto"
                                                        clearable
                                                        @click:clear="fechaHasta = null"
                                                    />
                                                </template>
                                                <v-date-picker v-model="fechaHasta" no-title scrollable @input="menu4 = false" />
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-select
                                                dense
                                                v-model="filtroEstado"
                                                :items="estadosFiltro"
                                                item-text="descripcion"
                                                item-value="id"
                                                label="ESTADO"
                                                hide-details="auto"
                                                clearable
                                                @change="getListaCot({ state: true })"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field
                                                dense
                                                v-model="numeroCotizacion"
                                                label="NRO COT"
                                                hide-details="auto"
                                                clearable
                                                type="number"
                                                @keyup.enter="getListaCot({ state: true })"
                                                @click:clear="
                                                    numeroCotizacion = null
                                                    getListaCot({ state: true })
                                                "
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field
                                                dense
                                                v-model="numeroDocumento"
                                                label="NRO DOCUMENTO"
                                                hide-details="auto"
                                                clearable
                                                @keyup.enter="getListaCot({ state: true })"
                                                @click:clear="
                                                    numeroDocumento = null
                                                    getListaCot({ state: true })
                                                "
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field
                                                dense
                                                v-model="nombreCliente"
                                                label="NOMBRE CLIENTE"
                                                hide-details="auto"
                                                clearable
                                                @keyup.enter="getListaCot({ state: true })"
                                                @click:clear="
                                                    nombreCliente = null
                                                    getListaCot({ state: true })
                                                "
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field
                                                dense
                                                v-model="descripcionProducto"
                                                label="DESCRIPCION PRODUCTO"
                                                hide-details="auto"
                                                clearable
                                                @keyup.enter="getListaCot({ state: true })"
                                                @click:clear="
                                                    descripcionProducto = null
                                                    getListaCot({ state: true })
                                                "
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="3" class="d-flex align-center">
                                            <v-btn small color="primary" dark @click="getListaCot({ state: true })">
                                                BUSCAR <v-icon right small>mdi-magnify</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-row>
                                        <v-col cols="12"> <strong>ACTIONS</strong></v-col>

                                        <v-col cols="4" class="text-center">
                                            <v-btn small color="primary" dark @click="toggleForm">
                                                {{ showForm ? 'OCULTAR FORM' : 'NUEVA COTIZACIÓN' }}
                                                <v-icon right small>mdi-plus-box</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="4" class="text-center">
                                            <v-btn small color="blue" :loading="loadingCotizacion" dark @click="getListaCot(true)">
                                                RELOAD <v-icon right dark> mdi-autorenew </v-icon></v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-container>
            </div>
            <v-card-title class="grey lighten-4">
                <b>LISTA DE COTIZACIONES</b>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table
                            multi-sort
                            :loading="loadingCotizacion"
                            :headers="headers"
                            :items="_listaCotizaciones"
                            class="elevation-1"
                            :server-items-length="totalCotizaciones"
                            :items-per-page="20"
                            @update:options="onTableOptions"
                        >
                            <template v-slot:[`item.idVenta`]="{ item }">
                                <v-chip small :color="estadoColor(item.idEstado)" text-color="white" @click="openModalEstado(item)" style="cursor: pointer">
                                    {{ estadoLabel(item) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item._id`]="{ item }">
                                <div>
                                    <strong>{{ item.id }}</strong>
                                    <div class="caption grey--text">{{ item.origen }}</div>
                                </div>
                            </template>

                            <template v-slot:[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="green" small @click="editItem(item)">mdi-pencil</v-icon>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="blue" small @click="printItem(item)">mdi-cloud-print</v-icon>
                                    </template>
                                    <span>Imprimir</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            color="orange"
                                            small
                                            :disabled="!!item.idVenta"
                                            :class="{ 'op-disabled': !!item.idVenta }"
                                            @click="item.idVenta ? null : openModalVenta(item)"
                                            >mdi-cart</v-icon
                                        >
                                    </template>
                                    <span>{{ item.idVenta ? 'Ya tiene venta generada' : 'Generar Venta' }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="orange" small @click="changeDollars(item)">S/.</v-icon>
                                    </template>
                                    <span>Cambiar a Soles</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="primary" small @click="deleteItem(item)">mdi-delete</v-icon>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            :color="item.isNotification == 1 ? 'green' : 'red'"
                                            small
                                            @click="NotificationItem(item)"
                                            >mdi-bell</v-icon
                                        >
                                    </template>
                                    <span>Notificación</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="purple" small @click="openModalEstado(item)">mdi-flag-outline</v-icon>
                                    </template>
                                    <span>Cambiar Estado</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-dialog v-model="dialog3" max-width="300px">
                <v-card>
                    <v-card-title>
                        <span>Desea Crear una Venta?</span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-actions>
                        <v-btn color="primary" text @click="dialog3 = false"> Close </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="actionModalVenta"> CREAR </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="openChangeDollars" max-width="290">
                <v-card>
                    <v-col>
                        <v-row>
                            <v-col cols="12">
                                <form @submit.prevent="cambiarDolar" ref="formTipoCambio">
                                    <v-col class="text-h6 pa-1" cols="12">CAMBIO A SOLES</v-col>
                                    <v-text-field class="px-3" @keypress="isNumber" v-model="changeTipoCambio" label="Tipo de Cambio" required></v-text-field>
                                    <v-col cols="12" sm="3" class="text-center">
                                        <v-btn block color="secondaryTheme" dark type="submit">Cambiar</v-btn>
                                    </v-col>
                                </form>
                            </v-col>
                        </v-row>
                    </v-col>
                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-1" text @click="cambiarDolar"> Agree </v-btn>
                  </v-card-actions> -->
                </v-card>
            </v-dialog>
            <CambiarEstadoCotizacion
                ref="cambioEstadoModal"
                :open="dialogEstado"
                :cotizacion="selectedCotizacionEstado"
                @close="dialogEstado = false"
                @confirm="cambiarEstadoCotizacion"
            />
        </v-card>
    </v-container>
</template>
<script>
const { formatInTimeZone } = require('date-fns-tz')
import { mapState, mapGetters, mapMutations } from 'vuex'
import { mixins } from '@/mixins/mixin.js'
import DefaultForm from '@/utils/defaultForm'
import { sortItems, exportXLSX } from '@/utils/genericUtils'
import ClientePanel from '@/components/clientes/ClientePanel'
import { format, addDays, getDay, getMonth, getDate, subMonths } from 'date-fns'
import ModalReserva from '@/components/modals/ModalReserva'
import CambiarEstadoCotizacion from '@/components/modals/CambiarEstadoCotizacion'
import SelectProductos from '@/components/selects/SelectProductos'
import SelectUbigeo from '@/components/selects/SelectUbigeo'
import { debounce } from 'lodash'

export default {
    components: {
        ModalReserva,
        SelectProductos,
        CambiarEstadoCotizacion,
        ClientePanel,
        SelectUbigeo
    },
    mixins: [mixins],
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            mensajeNotificacion: ``,
            diasEntrega: 10,
            dialog3: false,
            openChangeDollars: false,
            dialogEstado: false,
            selectedCotizacionEstado: {},
            itemsChageDollars: null,
            changeTipoCambio: null,
            stateUpdate: false,
            showForm: false,
            fechaFiltro: format(subMonths(new Date(), 1), 'yyyy-MM-dd'),
            fechaHasta: format(new Date(), 'yyyy-MM-dd'),
            filtroEstado: null,
            numeroDocumento: null,
            numeroCotizacion: null,
            nombreCliente: null,
            descripcionProducto: null,
            page: 1,
            itemsPerPage: 20,
            lastSkip: -1,
            lastLimit: 20,
            openDocumento: false,
            isDistrito: null,
            usarDireccionCliente: false,
            formaPagoSelected: null,
            opcionesFormaPago: [
                { text: '50% para la fabricación y 50% para programar el despacho', value: '50% para la fabricación y 50% para programar el despacho' },
                { text: '100% contraentrega', value: '100% contraentrega' },
                { text: '100% por adelantado', value: '100% por adelantado' },
                { text: 'Otro (especifique)', value: '__OTRO__' }
            ],
            menu: false,
            menu2: false,
            menu3: false,
            menu4: false,
            formClient: DefaultForm.formClient(),
            loadingCotizacion: false,
            _clienteFilledFromPanel: false, // flag: true when client-selected event provided the data
            step: 1,
            fecha: format(new Date(), 'yyyy-MM-dd'),
            loading: false,
            form: DefaultForm.formCotizacion(),
            loading2: false,
            headers: [
                { text: '', value: 'action', sortable: false },
                { text: 'Estado', value: 'idVenta' },
                { text: 'Nro Cot', value: '_id' },
                { text: 'Usuario Creación', value: 'nombreColaboradorCreacion' },
                { text: 'Usuario Asignado', value: 'nombreColaborador' },
                { text: 'fec. Emision', value: 'fechaEmision' },
                { text: 'fec. Actualizacion', value: 'fechaActualizacion' },
                { text: 'Hora Emision', value: 'horaEmision' },
                { text: 'Cliente', value: 'full_name' },
                { text: 'Doc. Cliente', value: 'numeroDocumento' },
                { text: 'Descripción', value: 'productoDetalle' },
                { text: 'S/', value: 'montoSoles' },
                { text: '$', value: 'montoDolares' }
            ]
        }
    },
    computed: {
        ...mapState('utilities', ['tipoComprobanteFact', 'tipoPago', 'tipoMoneda', 'tipoDocumento', 'tipoBancoDestino', 'listOrigen']),
        ...mapState('users', ['user']),
        ...mapState('pagos', ['bancoTipoCambio', 'external_tipoCambio']),
        ...mapGetters('users', ['optionalRole']),

        ...mapState('ventas', ['productos', 'modalReserva']),
        ...mapGetters('cotizaciones', ['listaCotizaciones', 'estadosCotizacion', 'totalCotizaciones']),

        estadosFiltro() {
            return [{ id: null, descripcion: 'Todos' }, ...this.estadosCotizacion]
        },

        _listaCotizaciones() {
            const itemCotizacion = []
            try {
                this.listaCotizaciones.forEach((x) => {
                    const itemsProductos = x.itemsProductos ? JSON.parse(x.itemsProductos) : []
                    const detalle = itemsProductos.map((y) => y.description)

                    const isFind = this.listOrigen.find((y) => y == x.origen)
                    const fechaCompleta = new Date(x.created_at)
                    const horaFormateada = `${fechaCompleta.getUTCHours()}:${fechaCompleta.getUTCMinutes().toString().padStart(2, '0')}`
                    const timePeriod = fechaCompleta.getUTCHours() >= 12 ? 'PM' : 'AM'
                    const cotizacion = {
                        ...x,
                        horaEmision: `${horaFormateada} ${timePeriod}`,
                        fechaActualizacion: formatInTimeZone(x.updated_at, 'UTC', 'yyyy-MM-dd HH:mm'),

                        origen: isFind || 'OTROS',
                        altOrigen: isFind ? null : x.origen,
                        productoDetalle: detalle.join().slice(0, 30),
                        tieneDatosCliente: Boolean(x.idCliente),
                        full_name: x.full_name || x.nameDefault,
                        _id: String('000000' + x.id).slice(-6),
                        nombreColaboradorCreacion: x.nombreColaboradorCreacion ?? 'SYSTEM'
                    }
                    itemCotizacion.push(cotizacion)
                })
                let optionalRole = {}
                try {
                    optionalRole = this.user.optionalRole ? JSON.parse(this.user.optionalRole) : {}
                } catch (e) {
                    optionalRole = {}
                }

                const listWeb = itemCotizacion.filter((el) => el.origen == 'WEB' && !el.idUsuarioModificacion)
                const itemJunior = optionalRole.newVendor
                    ? itemCotizacion.filter((x) => x.idUsuarioModificacion == this.user.id).concat(listWeb)
                    : itemCotizacion
                return itemJunior

                return itemCotizacion
            } catch (error) {
                //console.log('lol ', error)
            }
        },
        importe() {
            let sumaSoles = 0
            let sumaDolares = 0
            this.productos.map((x) => {
                if (x.idTipoMoneda === 1) {
                    //console.log('sumaSolesx', x)
                    sumaSoles += Number(x.subTotal)
                } else {
                    //console.log('sumaDolares', x)

                    sumaDolares += Number(x.subTotal)
                }
            })
            return {
                sumaSoles: sumaSoles.toFixed(2),
                sumaDolares: sumaDolares.toFixed(2)
            }
        },
        _idCliente() {
            return this.form.idCliente
        },
        _stateUpdate() {
            return this.stateUpdate
        }
    },
    methods: {
        ...mapMutations({
            /*             RESET_FORM: 'clientes/RESET_FORM',
     UPDATE_DATOS: 'clientes/UPDATE_DATOS', */
            OPEN_MODAL: 'mainUI/OPEN_MODAL',
            OPEN_BAR: 'mainUI/OPEN_BAR'
        }),
        onClientePanelSelected(cliente) {
            // Called when user picks from search list — data already available, no fetch needed
            if (!cliente) return
            this._clienteFilledFromPanel = true
            this._fillClienteForm(cliente)
            this.usarDireccionCliente = true
        },

        _fillClienteForm(cliente) {
            this.form.telefono = cliente.telephone || null
            this.form.correo = cliente.email || null
            this.form.direccion = cliente.address || null
            this.form.numeroDocumento = cliente.number || ''
            this.form.full_name = cliente.name || ''
            this.form.idTipoComprobante = cliente.number && cliente.number.length === 11 ? 1 : 2
            this.isDistrito = cliente.district_id || null
        },
        _fillDireccionEnvio(cliente) {
            if (!cliente) return
            this.form.direccion = cliente.address || this.form.direccion
            this.isDistrito = cliente.district_id || null
        },
        crearClienteDesdeForm() {
            if (!this.form.nameDefault) return
            this.form.tieneDatosCliente = true
            this.$nextTick(() => {
                this.$refs.clientePanel?.abrirModalConDatos({
                    full_name: this.form.nameDefault,
                    telefono: this.form.telefono,
                    correo: this.form.correo
                })
            })
        },

        async performClientSearch(searchText) {
            this.isClientSearching = true
            try {
                const results = await this.$store.dispatch('clientes/searchClientes', {
                    text: searchText,
                    idSede: this.user.idSede
                })

                // Format results for display
                this.clientSearchResults = results.map((c) => ({
                    ...c,
                    displayName: `${c.name} (${c.number})`,
                    numeroDocumento: c.number
                }))
            } catch (error) {
                console.error('Client search error:', error)
                this.clientSearchResults = []
            } finally {
                this.isClientSearching = false
            }
        },

        onClientSelected(client) {
            if (!client) return
            // Client selection is handled by v-model binding
            // Update form with client data if needed
        },

        async getClientById(idCliente) {
            if (!idCliente) return null
            try {
                // getClienteById returns the client object directly (or null)
                const cliente = await this.$store.dispatch('clientes/getClienteById', idCliente)
                return cliente || null
            } catch (error) {
                console.error('Error fetching client:', error)
                return null
            }
        },

        async sendWhatsapp() {
            const phone = this.form.telefono

            if (!phone) {
                this.OPEN_MODAL({
                    state: true,
                    text: 'ERROR - Número de teléfono no disponible',
                    color: 'red'
                })
                return
            }

            const mensaje = `${this.mensajeNotificacion}
${this.form.urlProducto || ''}`

            const original = String(phone || '')
            const raw = original.replace(/\D+/g, '')
            const normalized = raw.startsWith('51') ? raw : `51${raw}`
            if (!/^51\d{7,12}$/.test(normalized)) {
                this.OPEN_MODAL({ state: true, text: 'ERROR - Número inválido para WhatsApp', color: 'red' })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized}?text=${encodeURIComponent(mensaje)}`
            window.open(whatsappUrl, '_blank')
        },
        async editItem(v) {
            const item = Object.assign({}, v)
            this.$store.commit('mainUI/OPEN_MODAL', { state: true })
            const dataProyect = JSON.parse(item.datosProyecto)
            console.log('dataProyect', dataProyect)
            console.log('item', item)
            this.form = {
                ...dataProyect,
                sendMail: false,
                isSendMail: item.sendMail,
                ...item,
                tipoCambio: item.tipoCambio
            }
            console.log('this.form----', this.form)
            if (item.ubigeo) {
                this.isDistrito = item.ubigeo
            } else {
                this.isDistrito = null
            }
            this.$store.commit('ventas/UPDATE_PRODUCTOS', JSON.parse(item.itemsProductos))
            this.step = 2
            this.showForm = true
            this.$store.commit('mainUI/OPEN_MODAL', { state: false })
            window.scrollTo(0, 0)
        },
        async printItem(item) {
            console.log('item ', item)
            this.$store.commit('mainUI/OPEN_MODAL', { state: true, text: 'Generando Reporte' })

            await this.$store.dispatch('reporte/reporteCotizacion', { ...item, distrito: item.distrito || '' })
            this.$store.commit('mainUI/OPEN_MODAL', { state: false })
        },
        async createVenta(v) {
            this.dialog3 = false
            this.selectedVenta = null
            const item = Object.assign({}, v)
            //console.log('createVenta ', item)
            const festivos = []
            let diaPedido = formatInTimeZone(new Date(), 'America/Lima', 'yyyy-MM-dd HH:mm')
            diaPedido = new Date(diaPedido)
            console.log('diaPedido', diaPedido)
            function calculaEntrega(diaPedido, diasPactados, festivos) {
                let diaPropuesto = diaPedido
                let i = 1

                while (diasPactados > 0) {
                    let festivo = false
                    diaPropuesto = addDays(diaPedido, i)

                    // Verifica si es día laboral (Lunes a Viernes: 1-5)
                    if (getDay(diaPropuesto) > 0 && getDay(diaPropuesto) < 6) {
                        const m = getMonth(diaPropuesto)
                        const dia = getDate(diaPropuesto)

                        for (let d in festivos[m]) {
                            if (dia === festivos[m][d]) {
                                festivo = true
                                break
                            }
                        }

                        if (!festivo) {
                            diasPactados--
                        }
                    }

                    i++
                }

                return diaPropuesto
            }
            this.$store.commit('ventas/RESET_DATOS')
            this.$store.commit('mainUI/OPEN_MODAL', { state: true, text: 'Generando Venta' })
            const itemsProductos = item.itemsProductos ? JSON.parse(item.itemsProductos) : []
            let importeTotal = 0
            let idTipoMoneda = 1
            itemsProductos.map((x) => {
                idTipoMoneda = x.idTipoMoneda ? x.idTipoMoneda : 1

                importeTotal += Number(x.subTotal)
            })
            const idCotizacion = item.id
            item.id = null
            //item.idCliente = null
            const cliente = await this.getClientById(item.idCliente)
            //form.diasEntrega
            let diasEntrega = parseInt(item.diasEntrega)
            diasEntrega = calculaEntrega(diaPedido, diasEntrega, festivos)
            console.log('diasEntrega', diasEntrega)
            // if (diasEntrega == 5) {
            //     diasEntrega = diasEntrega + 2
            // } else if (diasEntrega == 10) {
            //     diasEntrega = diasEntrega + 4
            // }
            //console.log('diasEntrega', diasEntrega)
            // let check_in = format(addBusinessDays(new Date(), diasEntrega), 'yyyy-MM-dd')
            let check_in = format(diasEntrega, 'yyyy-MM-dd')
            //console.log('check_in ', check_in)
            delete item.id
            delete item._id

            // Agregar dimensiones del proyecto a observaciones
            let obsFin = item.observaciones || ''
            try {
                const dp = typeof item.datosProyecto === 'string' ? JSON.parse(item.datosProyecto) : item.datosProyecto
                if (dp && (dp.largo || dp.ancho || dp.alto)) {
                    const dims = `medidas del sauna ${dp.largo || '?'} x ${dp.ancho || '?'} x ${dp.alto || '?'}`
                    obsFin = obsFin ? `${obsFin} / ${dims}` : dims
                }
            } catch (e) { /* datosProyecto no parseable, se ignora */ }

            const body = {
                ...item,
                idColaborador: item.idUsuarioModificacion,
                idTipoMoneda,
                idTipoDocumento: cliente ? cliente.idTipoDocumento : null,
                tipoVenta: 2,
                idCotizacion,
                check_in,
                observation: obsFin,
                importeTotal,
                finalizado: 0,
                status: 1,
                productos: item.itemsProductos,
                idUserAssignment: item.idUsuarioModificacion
            }
            console.log('body-----', body)
            this.$store.commit('ventas/UPDATE_PRODUCTOS', itemsProductos)

            //console.log('body --> ', body)

            this.$store.commit('ventas/UPDATE_DATOS', body)
            this.$store.commit('ventas/SHOW_MODAL', { step: 2, state: true })

            this.$store.commit('mainUI/OPEN_MODAL', { state: false })
        },

        async deleteItem(item) {
            await this.$store.dispatch('cotizaciones/deleteCotizacion', {
                id: item.id
            })
            this.$store.commit('mainUI/OPEN_MODAL', {
                state: true,
                text: 'Eliminado satisfactoriamente'
            })
            await this.getListaCot({ state: true })
            this.loadingCotizacion = true
            this.$store.commit('mainUI/OPEN_MODAL', { state: false })
            this.loadingCotizacion = false
        },
        async NotificationItem(item) {
            console.log('item', item)
            const { telefono, itemsProductos, idCliente, datosProyecto } = item

            if (!telefono) {
                this.OPEN_MODAL({
                    state: true,
                    text: 'ERROR - Número de teléfono no disponible',
                    color: 'red'
                })
                return
            }

            const findClient = await this.getClientById(idCliente)
            console.log('findClient', findClient)
            const products = JSON.parse(itemsProductos)
            const numProducts = products.length
            const productosTexto = ` 📦${products[0].description} ${numProducts - 1 == 0 ? '' : ` más ${numProducts - 1} producto(s) más.`}`

            const message = `Hola ${findClient.defaultName},

Te informamos que tu cotización está lista.
${productosTexto}

Para más detalles, no dudes en contactarnos.

Saludos,
Cuba & Spa`

            const original2 = String(telefono || '')
            const raw2 = original2.replace(/\D+/g, '')
            const normalized2 = raw2.startsWith('51') ? raw2 : `51${raw2}`
            if (!/^51\d{7,12}$/.test(normalized2)) {
                this.OPEN_MODAL({ state: true, text: 'ERROR - Número inválido para WhatsApp', color: 'red' })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized2}?text=${encodeURIComponent(message)}`
            window.open(whatsappUrl, '_blank')

            await this.$store.dispatch('cotizaciones/updateCotizaciones', {
                ...item,
                itemsProductos: products,
                datosProyecto: JSON.parse(datosProyecto),
                isNotification: 1
            })
            await this.getListaCot({ state: true })
        },
        async addCotizacion(name) {
            console.log('this.$validator', this.$validator)

            this.$validator
                .validateAll(name)
                .then(async (result) => {
                    console.log('result', result)
                    let text = 'Generando Cotización'

                    if (result) {
                        try {
                            this.loading = true
                            this.$store.commit('mainUI/OPEN_MODAL', {
                                state: true,
                                text
                            })
                            const { direccion } = this.form
                            const distrito = this.isDistrito || ''
                            const myTimezone = formatInTimeZone(new Date(), 'America/Lima', 'yyyy-MM-dd')
                            console.log('myTimezone', myTimezone)
                            const data = {
                                ...this.form,
                                origen: this.form.origen == 'OTROS' ? this.form.altOrigen : this.form.origen,
                                datosProyecto: {
                                    alto: this.form.alto,
                                    ancho: this.form.ancho,
                                    largo: this.form.largo
                                },
                                tipoCambio: this.form.tipoCambio,
                                idUsuarioModificacion: this.user.id,
                                direccion: direccion ? `${direccion}` : '',
                                itemsProductos: this.productos,
                                ubigeo: this.isDistrito || '',
                                distrito,
                                montoSoles: this.importe.sumaSoles,
                                montoDolares: this.importe.sumaDolares,
                                full_name: this.form.full_name || this.form.nameDefault,
                                fechaEmision: myTimezone
                            }
                            console.log('dataCotizacion', data)
                            if (this.step == 1) {
                                await this.$store.dispatch('cotizaciones/postCotizaciones', data)
                            } else {
                                await this.$store.dispatch('cotizaciones/updateCotizaciones', data)
                                text = 'Actualizado exitosamente'
                            }

                            this.form = DefaultForm.formCotizacion()
                            this.formClient = DefaultForm.formClient()

                            this.isDistrito = null
                            await this.getListaCot({ state: true })
                            //console.log('UPDATE_PRODUCTOS ', this.productos)
                            this.$store.commit('mainUI/OPEN_MODAL', {
                                state: false,
                                text
                            })
                            this.step = 1
                            this.showForm = false
                            this.loading = false
                            this.$store.commit('ventas/UPDATE_PRODUCTOS', [])
                        } catch (error) {
                            //console.log('err-> ', error)
                            text = 'Ha ocurrido un Error'
                            this.loading = false
                        }
                    } else {
                        //console.log('result ', result)
                    }
                    this.$store.commit('mainUI/OPEN_MODAL', {
                        state: false
                    })
                })
                .catch((e) => {
                    //console.log('Eerr ', e)
                    this.loading = false
                })
        },
        fnListener(v) {
            console.log('v', v)
            this.form.idCliente = v
            this.openModalProveedor = false
        },
        fnUpdate(v) {
            this.stateUpdate = v
        },
        cambiarDolar() {
            this.$validator.validateAll('formTipoCambio').then(async (result) => {
                console.log('this.$validator', this.$validator)
                if (result) {
                    await this.$store.dispatch('cotizaciones/changeDollars', { ...this.itemsChageDollars, tc: this.changeTipoCambio })
                    this.openChangeDollars = false
                    await this.getListaCot({ state: true })
                    //console.log('UPDATE_PRODUCTOS ', this.productos)
                }
            })
        },
        clientCache(v) {
            this.openModalProveedor = false
        },
        toggleForm() {
            this.showForm = !this.showForm
            if (!this.showForm) {
                this.step = 1
                this.form = DefaultForm.formCotizacion()
                this.$store.commit('ventas/UPDATE_PRODUCTOS', [])
            }
        },
        onTableOptions({ page, itemsPerPage }) {
            const skip = (page - 1) * itemsPerPage
            if (skip === this.lastSkip && itemsPerPage === this.lastLimit) return
            this.lastSkip = skip
            this.lastLimit = itemsPerPage
            this.page = page
            this.itemsPerPage = itemsPerPage
            this.getListaCot({ state: true, skip, limit: itemsPerPage })
        },
        async getListaCot({ state = true, skip = 0, limit = 20 }) {
            this.loadingCotizacion = true
            if (skip === 0) {
                this.lastSkip = -1
                this.lastLimit = 20
            }
            try {
                await this.$store.dispatch('cotizaciones/getLista', {
                    fechaFiltro: this.fechaFiltro,
                    fechaHasta: this.fechaHasta,
                    idEstado: this.filtroEstado,
                    idCotizacion: this.numeroCotizacion,
                    numeroDocumento: this.numeroDocumento,
                    nombreCliente: this.nombreCliente,
                    descripcionProducto: this.descripcionProducto,
                    state,
                    skip,
                    limit
                })
            } catch (error) {
                console.error('getListaCot error', error)
            } finally {
                this.loadingCotizacion = false
                this.menu3 = false
            }
        },

        // getListaClientes removed — bulk client list no longer used
        downloadHandle() {
            this.loading = true
            const headers = [
                'id',
                'estado',
                'created_at',
                'sede',
                'fechaEmision',
                'formaPago',
                'full_name',
                'nombreColaborador',
                'numeroDocumento',
                'observaciones',
                'itemsProductos'
            ]
            const arrayData = []
            this._listaCotizaciones.map((x) => {
                arrayData.push({
                    ...x,
                    itemsProductos: JSON.parse(x.itemsProductos)[0]?.description,
                    estado: x.descEstado || (x.idVenta ? `VENDIDO T-${x.idVenta}` : 'Sin estado')
                })
            })
            const filename = `REPORT_cotizacion_${Date.now()}`
            exportXLSX({ headers, campos: headers, arrayData }, { filename })
            this.loading = false
        },
        closeDocumento(nombreModal) {
            this[nombreModal] = false
        },
        async getCotByDoc(payload) {
            const numeroDocumento = payload.numeroDocumento
            this.numeroDocumento = numeroDocumento
            await this.getListaCot({ state: true })
            this.openDocumento = false
        },
        async actionModalVenta() {
            await this.createVenta(this.selectedVenta)
        },
        async openModalVenta(item) {
            //console.log('item ', item)
            this.selectedVenta = item
            this.dialog3 = true
        },
        async changeDollars(item) {
            console.log('item', item)
            this.openChangeDollars = true
            this.itemsChageDollars = item
        },
        estadoColor(idEstado) {
            if (!idEstado) return 'orange'
            const colors = {
                1: 'blue',
                2: 'cyan',
                3: 'teal',
                4: 'indigo',
                5: 'deep-purple',
                6: 'amber darken-1',
                7: 'orange darken-1',
                8: 'light-blue',
                9: 'green',
                10: 'red',
                11: 'grey'
            }
            return colors[idEstado] || 'grey'
        },
        estadoLabel(item) {
            if (item.idEstado) {
                const found = this.estadosCotizacion.find((e) => e.id === item.idEstado)
                if (found) return found.descripcion
            }
            return item.idVenta ? 'Vendido' : 'Sin estado'
        },
        openModalEstado(item) {
            this.selectedCotizacionEstado = { ...item, idEstado: item.idEstado || 0 }
            this.dialogEstado = true
        },
        openModalEstadoDesdeForm() {
            this.selectedCotizacionEstado = {
                id: this.form.id,
                idEstado: this.form.idEstado || 1,
                descEstado: this.estadoLabel({ idEstado: this.form.idEstado, idVenta: this.form.idVenta })
            }
            this.dialogEstado = true
        },
        async cambiarEstadoCotizacion({ id, idEstado, observaciones }) {
            try {
                this.$store.commit('mainUI/OPEN_MODAL', { state: true, text: 'Actualizando estado...' })
                await this.$store.dispatch('cotizaciones/updateEstadoCotizacion', {
                    id,
                    idEstado,
                    usuario: this.user.usuario || this.user.full_name || 'Sistema',
                    observaciones
                })
                this.form.idEstado = idEstado
                this.selectedCotizacionEstado = { ...this.selectedCotizacionEstado, idEstado, descEstado: this.estadoLabel({ idEstado }) }
                await this.getListaCot({ state: true })
                this.$refs.cambioEstadoModal?.onEstadoChanged()
                this.$store.commit('mainUI/OPEN_MODAL', { state: false, text: 'Estado actualizado' })
            } catch (error) {
                this.$store.commit('mainUI/OPEN_MODAL', { state: true, text: 'Error al actualizar estado', color: 'red' })
            }
        }
    },
    watch: {
        'form.idCliente'(val) {
            if (!val) {
                this.usarDireccionCliente = false
            }
        },
        async usarDireccionCliente(val) {
            if (val && this.form.idCliente) {
                const cliente = await this.getClientById(this.form.idCliente)
                if (cliente) {
                    this._fillDireccionEnvio(cliente)
                }
            }
        },
        clientSearch: debounce(function (val) {
            if (!val || val.trim().length < 4) {
                this.clientSearchResults = []
                return
            }
            this.performClientSearch(val)
        }, 500),
        async _stateUpdate(val) {
            if (this.form.idCliente) {
                console.log('_stateUpdate', val)
                console.log('client watch')
                this.isDistrito = null
                this.form.telefono = null
                this.form.correo = null
                this.form.direccion = null
                const isCliente = await this.getClientById(this.form.idCliente)
                if (isCliente) {
                    console.log('isCliente', isCliente)
                    this.form.telefono = isCliente.telephone || null
                    this.form.correo = isCliente.email || null
                    this.form.idTipoComprobante = isCliente.number.length == 11 ? 1 : 2
                    this.form.direccion = isCliente.address || null
                    this.form.numeroDocumento = isCliente.number || ''
                    this.form.full_name = isCliente.name || ''
                    this.isDistrito = isCliente.district_id || null
                }
            }
            this.stateUpdate = false
        },
        async _idCliente(val) {
            // Skip fetch if data already came from client-selected event (search pick)
            if (this._clienteFilledFromPanel) {
                this._clienteFilledFromPanel = false
                return
            }
            if (!parseInt(val)) return
            // Only fetch when loading an existing cotizacion (idCliente set but no client data yet)
            const isCliente = await this.getClientById(val)
            if (isCliente) {
                this._fillClienteForm(isCliente)
            }
        },

        productos: {
            deep: true,
            handler(val) {
                if (val.length > 0) {
                    const idTipoMoneda = val[0].idTipoMoneda
                    this.form.idTipoMoneda = idTipoMoneda
                    //  this.form.tipoCambio = idTipoMoneda === 1 ? null : null
                }
            }
        },
        modalReserva: {
            deep: true,
            handler(val) {
                //console.log('val ', val)
                if (!val.state) {
                    this.$store.commit('ventas/RESET_DATOS')
                }
            }
        },
        formaPagoSelected(val) {
            if (val && val !== '__OTRO__') {
                this.form.formaPago = val
            } else if (!val) {
                this.form.formaPago = ''
            }
        }
    },
    async created() {
        this.loadingCotizacion = true
        // Sincronizar formaPagoSelected con el valor actual de form.formaPago
        const match = this.opcionesFormaPago.find((o) => o.value === this.form.formaPago)
        this.formaPagoSelected = match ? this.form.formaPago : this.form.formaPago ? '__OTRO__' : null
        this.$store.commit('ventas/UPDATE_PRODUCTOS', [])
        this.$store.commit('sedes/RESET_UBIGEO')
        await Promise.all([this.$store.dispatch('pagos/tipoCambio'), this.getListaCot({ state: true })])
        // No asignar tipo de cambio automático - debe ser manual
        // this.form.tipoCambio = this.external_tipoCambio
        //  await this.$store.dispatch('productos/getLista', { online: false })

        //await this.getListaClientes(false)

        this.loadingCotizacion = false
    }
}
</script>

<style scoped>
.op-disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
}
</style>
